var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":"AIzaSyCBSPp1PzEAqP35WskqYgTct-FRgJf8Vbk","bondMarkers":_vm.markers,"language":_vm.mapLang},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker){return _c('GoogleMapMarker',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map}})})}}])},[_vm._v("\n// insert your google maps api key to render styled map\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }